import { type ReactNode } from "react";
import { Box } from "@mui/material";
import logo from "../../../assets/logo-passtrack.png";
import entryBackground from "../../../assets/Passtrack-ingreso-1024x1024.jpg";
import { passtrackColors } from "../theme";

export const entryShellSx = {
  height: "100dvh",
  width: "100%",
  maxHeight: "100dvh",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  px: 2.5,
  boxSizing: "border-box",
  position: "relative",
  backgroundImage: `url(${entryBackground})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, rgba(10,42,107,.28) 0%, rgba(10,42,107,.45) 100%)",
    pointerEvents: "none",
  },
  "& > *": {
    position: "relative",
    zIndex: 1,
  },
} as const;

export const entryCardSx = {
  width: "100%",
  maxWidth: 420,
  maxHeight: "calc(100dvh - 32px)",
  overflow: "auto",
  p: { xs: 3, sm: 4 },
  borderRadius: 3,
  borderColor: passtrackColors.borderSubtle,
  background: "rgba(255,255,255,.96)",
  boxShadow: "0 16px 40px rgba(10,42,107,.22)",
} as const;

export const entryMenuCardSx = {
  ...entryCardSx,
  maxWidth: 480,
  p: { xs: 3.5, sm: 5 },
  textAlign: "center",
} as const;

export function EntryShell({ children }: { children: ReactNode }) {
  return <Box sx={entryShellSx}>{children}</Box>;
}

export function EntryLogo() {
  return (
    <Box
      component="img"
      src={logo}
      alt="PassTrack"
      sx={{ height: 48, mb: 2, display: "block", mx: "auto" }}
    />
  );
}
